(function () {
  const PARAM_KEY = 'key';
  const STORAGE_KEY = 'member_no';

  // -----------------------------
  // クエリパラメータ取得
  // -----------------------------
  function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  // -----------------------------
  // カートのattributesへ反映(サーバー側)
  // -----------------------------
  function updateCartAttribute(memberNo) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { member_no: memberNo }
      })
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('cart/update.js failed: ' + res.status);
        }
        return res.json();
      })
      .then(function (cart) {
        console.log('member_no reflected in cart attributes:', cart.attributes);
        return cart;
      })
      .catch(function (err) {
        console.error('Failed to update cart attribute:', err);
      });
  }

  // -----------------------------
  // 保存処理(クエリパラメータ検知時)
  // -----------------------------
  function saveMemberNo() {
    const memberNo = getQueryParam(PARAM_KEY);
    if (!memberNo) return;

    localStorage.setItem(STORAGE_KEY, memberNo);
    console.log('member_no saved to localStorage:', memberNo);

    // 検知した瞬間にサーバー側カートにも反映
    updateCartAttribute(memberNo);
  }

  // -----------------------------
  // カートに商品がまだ0件の場合の保険
  // (add to cart後にattributesが上書き/リセットされるケースに備える)
  // -----------------------------
  function reapplyMemberNoIfNeeded() {
    const memberNo = localStorage.getItem(STORAGE_KEY);
    if (!memberNo) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // 既にセット済みなら何もしない
        if (cart.attributes && cart.attributes.member_no === memberNo) {
          return;
        }
        // カートにアイテムがある場合のみ再送(空カートへの無駄な書き込みを避ける)
        if (cart.item_count > 0) {
          updateCartAttribute(memberNo);
        }
      })
      .catch(function (err) {
        console.error('Failed to check cart state:', err);
      });
  }

  // -----------------------------
  // 初期実行
  // -----------------------------
  document.addEventListener('DOMContentLoaded', function () {
    saveMemberNo();          // ?key=xxx が付いていればそのまま保存＆反映
    reapplyMemberNoIfNeeded(); // ?key=xxx がなくても、localStorageにあれば毎ページロードで保証
  });
})();